import { dataColorPaletteSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconColorPaletteSolid = /*#__PURE__*/createIcon(dataColorPaletteSolid)
export default IconColorPaletteSolid
